import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Container = styled.div`
  width: 100vw;
  background-color: ${themeGet('colors.background')};
  overflow: hidden;
`
